<template>
  <div id="PolicyList" style="height: 100%">

    <van-overlay :show="loading">
      <div class="wrapper">
        <van-loading size="40px" vertical>请求中...</van-loading>
      </div>
    </van-overlay>
    <van-divider contentPosition="center" v-if="list && list.length >0">
      <span style="font-weight: bolder; font-size: large; color: #1f1235">
        保单列表
      </span>
    </van-divider>
    <van-list
        v-model="loading"
        :finished="finished"
        finished-text=""
        @load="onLoad"
    >
      <van-cell v-for="item in list" :key="item.id" size="large" @click="claimUpPage(item)"  style="background-color: #c0ebd7 ">
        <van-row type="flex" justify="space-between">
          <van-col style="font-size: 17px;" span="18">{{ item.productName }}</van-col>

          <van-col span="6" justify="end" style="text-align: right" v-if="3 == item.orderStatus">
            <van-tag size="medium" type="success">保障中</van-tag>
          </van-col>
          <van-col span="6" justify="end" style="text-align: right" v-else-if="5 == item.orderStatus">
            <van-tag size="medium" type="warning">已失效</van-tag>
          </van-col>
          <van-col span="6" justify="end" style="text-align: right" v-else-if="2 == item.orderStatus">
            <van-tag size="medium" type="warning">待生效</van-tag>
          </van-col>
          <van-col span="6" justify="end" style="text-align: right" v-else>
            <van-tag size="medium" type="primary">其他</van-tag>
          </van-col>
        </van-row>
        <p><samp><span style="font-weight: bolder">学员：</span>{{item.insuredName}}</samp></p>
        <p><samp><span style="font-weight: bolder">起期：</span>{{item.startTime}}</samp></p>
        <p><samp><span style="font-weight: bolder">止期：</span>{{item.endTime}}</samp></p>
        <van-row type="flex" justify="space-between" v-if="3 == item.orderStatus || 5 == item.orderStatus">
          <van-col style="font-size: 17px;" span="18"></van-col>
          <van-col span="6" justify="end" style="text-align: right;">
            <van-button size="large" type="info"> 点击申请理赔 </van-button>
          </van-col>
        </van-row>
      </van-cell>

      <!-- 理赔流程图 -->
      <div class="claim-progress-wrapper">
        <div class="claim-progress-title">理赔流程图：</div>
        <div class="claim-progress-flow">
          <div class="progress-row">
            <span class="progress-num">1</span>
            <span class="progress-step">扫码成功，等审核</span>
          </div>
          <span class="progress-arrow">➡</span>
          <div class="progress-row">
            <span class="progress-num">2</span>
            <span class="progress-step">状态显示“通过”字样，等打款</span>
          </div>
          <span class="progress-arrow">➡</span>
          <div class="progress-row">
            <span class="progress-num">3</span>
            <span class="progress-step">预计35天左右打款</span>
          </div>
          <span class="progress-arrow">➡</span>
          <div class="progress-row">
            <span class="progress-num">4</span>
            <span class="progress-step">结案（已打款）</span>
          </div>
        </div>
      </div>

      <van-cell v-if="haveDraftClaim" @click="goClaimUpPageByDraftClaim">
        <van-row type="flex" style="height: 50px" justify="space-between">
          <van-col style="font-size: 17px;" span="12"></van-col>
          <van-col span="12" justify="end" style="text-align: right;">
            <van-tag size="large" type="success"> 已有未完成的理赔草稿，是否点击进入 </van-tag>
          </van-col>
        </van-row>
      </van-cell>
    </van-list>


    <van-divider contentPosition="center" textColor="#1989fa" v-if="claimList && claimList.length >0">
      <span style="font-weight: bolder; font-size: large; color: #1f1235">
        理赔列表
      </span>
    </van-divider>

    <van-list
        finished-text=""
    >
      <van-cell v-for="item in claimList" :key="item.id" size="large" @click="claimEditPage(item)" >
        <p style="font-size: 17px;font-weight: bolder">{{ item.planName }} </p>
        <van-row type="flex" justify="space-between">
          <van-col style="font-size: 17px;" span="10"></van-col>
          <van-col style="font-weight: bolder;text-align: right;" span="4">状态：</van-col>
          <van-col span="10" justify="end" style="text-align: right"
                   v-if="3 === item.claimStatus || 5 === item.claimStatus || 8 === item.claimStatus || 16 === item.claimStatus || 17 === item.claimStatus || 19 === item.claimStatus">
            <van-tag size="medium" type="warning">{{ claimStatusMap[item.claimStatus] }}</van-tag>
          </van-col>
          <van-col span="10" justify="end" style="text-align: right" v-else-if="9 === item.claimStatus">
            <van-tag size="medium" type="success">{{ claimStatusMap[item.claimStatus] }}</van-tag>
          </van-col>
          <van-col span="10" justify="end" style="text-align: right"
                   v-else>
            <van-tag size="medium" type="primary">{{ claimStatusMap[item.claimStatus] }}</van-tag>
          </van-col>
        </van-row>

        <van-row type="flex" justify="space-between">
          <van-col style="font-size: 17px;" span="10"></van-col>
          <van-col style="font-weight: bolder;text-align: right;" span="4">时间：</van-col>
          <van-col span="10" justify="end" style="text-align: right;">
            {{item.updateTime}}
          </van-col>
        </van-row>

        <p><samp><span style="font-weight: bolder">被保险人：</span> {{item.insuredName}}</samp></p>
        <p v-if="item.driveReportVo"><samp><span style="font-weight: bolder">挂科时间：</span> {{item.driveReportVo.examTime}}</samp></p>
        <p v-if="item.driveReportVo"><samp><span style="font-weight: bolder">挂科科目：</span> {{ subjectMamp[item.driveReportVo.subject] }}</samp></p>
        <p><samp><span style="font-weight: bolder">备注：
        </span>
          <span
              style="background-color: coral;color: white"
              v-if="3 === item.claimStatus || 5 === item.claimStatus || 8 === item.claimStatus || 16 === item.claimStatus || 17 === item.claimStatus || 19 === item.claimStatus">
            {{item.remark}}
          </span>
          <span v-else>
            {{item.remark}}
          </span>
        </samp>
        </p>

        <van-row type="flex" justify="space-between">
          <van-col style="font-size: 17px;" span="18"></van-col>
          <van-col span="6" justify="end" style="text-align: right;">
            <van-button type="info">
              {{ 3 === item.claimStatus || 5 === item.claimStatus || 8 === item.claimStatus || 16 === item.claimStatus || 17 === item.claimStatus || 19 === item.claimStatus? "点击修改" : "详情" }}
            </van-button>
          </van-col>
        </van-row>
      </van-cell>
    </van-list>

    <van-dialog
        v-model="rejectionDialogVisible"
        :title="`驳回原因（${rejectionReasonIndex + 1}/${rejectionReasons.length}）`"
        :confirm-button-text="rejectionReasonIndex < rejectionReasons.length - 1 ? '确认，查看下一条' : '确认，继续修改'"
        confirm-button-color="#1989fa"
        :show-cancel-button="false"
        :close-on-click-overlay="false"
        :close-on-popstate="false"
        :before-close="confirmRejectionReason"
    >
      <p class="claim-rejection-hint">请仔细阅读，并按要求修改材料</p>
      <div :key="rejectionReasonIndex" class="claim-rejection-reason">{{ rejectionReasons[rejectionReasonIndex] }}</div>
    </van-dialog>

    <a-modal v-model="tipsVisible" title="提示">
      <template slot="footer">
        <a-button key="back" @click="goExamQr">
          考试截图授权
        </a-button>
        <a-button key="submit" type="primary" @click="goClaimInfo">
          详情
        </a-button>
      </template>

      <p>进入详情或者考试截图授权</p>
    </a-modal>

    <van-empty v-if="empty.isShow" :image="empty.image" :description="empty.description" />
  </div>
</template>

<script>
import {getClaimList, getClaimPolicyList, getDraftClaimList} from "@/api/claim";
import {splitClaimRejectionReasons} from "@/utils/claim-rejection-reasons";

export default {
  name:"PolicyList",
  data() {
    return {
      formDate:{
        insuredCardNo:"",
        insuredName:""
      },
      list: [],
      loading: false,
      finished: false,
      haveDraftClaim: false,
      draftClaim: {},
      empty:{
        isShow:false,
        image:"default",
        description:"信息不存在",
      },
      tipsVisible: false,
      rejectionDialogVisible: false,
      rejectionReasons: [],
      rejectionReasonIndex: 0,
      claimList: [],
      selectedClaim: {},
      subjectMamp:{
        1:"科目一",
        2:"科目二",
        3:"科目三",
        4:"科目四"
      },
      claimStatusMap:{
        1:"草稿",
        2:"审核中",
        3:"初审不通过",
        4:"初审通过",
        5:"保险公司审核不通过",
        6:"保险公司审核通过",
        7:"保险公司打款中",
        8:"保险公司打款失败",
        9:"已结案",
        10:"材料问题重提审核中",
        11:"122账户问题重提审核中",
        12:"收款账户问题审核中",
        13:"加急处理中",
        14:"拒赔结案",
        15:"考试截图中",
        16:"考试截图失败",
        17:"考试截图信息错误",
        18:"考试截图成功审核中",
        19:"渠道退回",
        20:"保险公司审核中",
        21:"风险账户",
        22:"已打款",
        23:"已初审通过保司打款中",
        24:"审核通过",
        25:"正在截图",
        26:"不支付理赔",
        27:"待授权",
        28:"授权有误请自行上传截图",
        29:"材料已发保险公司",
        30:"已通过"
      }
    };
  },
  methods: {
    onLoad() {
      // 异步更新数据
      this.formDate.insuredCardNo = this.$route.query.insuredCardNo;
      this.formDate.insuredName = this.$route.query.insuredName;
      this.loading = true;
      getClaimPolicyList({ insuredCardNo: this.formDate.insuredCardNo, insuredName: this.formDate.insuredName, page:1, limit:10 }).then(res => {
        if (200 === res.code) {
          this.list = res.data;
          if (0 === this.list.length) {
            this.empty.isShow = true;
          }
          this.loadDraftClaimList();
        }else {
          this.empty.isShow = true;
          this.empty.description = res.result.msg;
        }
        this.finished = true;
      }).catch(()=>{
        this.finished = true;
        this.empty.isShow = true;
        this.empty.image = "network";
        this.empty.description = "请求失败";
      }).finally(()=>{
        this.finished = true;
      });
      this.loadClaimList();
    },
    claimUpPage(item){
      if (3 == item.orderStatus || 5 == item.orderStatus) {
        this.$router.push({path: '/claim/claimInsert', query: {insuredCardNo: item.insuredCardNo, policyNo: item.policyNo}});
      }
    },
    loadDraftClaimList() {
      this.haveDraftClaim = false;
      getDraftClaimList({ insuredCardNo: this.formDate.insuredCardNo}).then(res => {
        if (200 === res.code) {
          if (res.data.length > 0) {
            this.haveDraftClaim = true;
            this.draftClaim = res.data[0];
          }
        }
      }).catch(()=>{
        this.finished = true;
      }).finally(()=>{
        this.finished = true;
      })
    },
    loadClaimList() {
      getClaimList({
        "insuredCardNo": this.formDate.insuredCardNo,
        "page":"1",
        "limit":"30" }).then(res => {
        if (200 === res.code) {
          this.claimList = res.data;
        }
      }).catch(()=>{
        this.finished = true;
      }).finally(()=>{
        this.finished = true;
        this.loading = false;
      });
    },

    goClaimUpPageByDraftClaim(){
      if (this.draftClaim && this.draftClaim.claimCode) {
        this.$router.push({path: '/claim/claimInsert', query: {claimCode: this.draftClaim.claimCode}});
      }
    },

    isShowOriginalPolicyNo(item) {
      if ('1048' == item.companyCode) {
        return true
      }
      return false
    },

    claimEditPage(item){
      if (this.rejectionDialogVisible) {
        return;
      }
      this.selectedClaim = item;
      if ([3, 5, 8, 16, 17, 19].includes(item.claimStatus)) {
        this.rejectionReasons = splitClaimRejectionReasons(item.remark);
        if (!this.rejectionReasons.length) {
          this.rejectionReasons = ['该理赔已被退回，暂未提供具体原因，请联系工作人员确认修改要求。'];
        }
        this.rejectionReasonIndex = 0;
        this.rejectionDialogVisible = true;
        return;
      }
      this.openSelectedClaim();
    },
    confirmRejectionReason(action, done) {
      if (!this.rejectionDialogVisible || action !== 'confirm') {
        done(false);
        return;
      }
      if (this.rejectionReasonIndex < this.rejectionReasons.length - 1) {
        this.rejectionReasonIndex += 1;
        done(false);
        return;
      }
      done();
      this.openSelectedClaim();
    },
    openSelectedClaim() {
      const item = this.selectedClaim;
      // 待授权
      if (27 === item.claimStatus) {
        this.tipsVisible = true;
      } else {
        //截图失败并且可以截图的
        if ((16 === item.claimStatus
                || 17 === item.claimStatus
                || 21 === item.claimStatus)
            && 2 === item.examAutoScreenshotType) {
          this.tipsVisible = true;
        } else {
          this.$router.push({path: '/claim/claimInfo', query: {claimCode: item.claimCode}});
        }
      }
    },
    goExamQr() {
      this.$router.push({path: '/claim/examQr', query: {claimCode: this.selectedClaim.claimCode}});
    },
    goClaimInfo() {
      this.$router.push({path: '/claim/claimInfo', query: {claimCode: this.selectedClaim.claimCode}});

    }

  },
}
</script>

<style lang="less" scoped>

.claim-rejection-hint {
  margin: 12px 24px;
  color: #646566;
  font-size: 14px;
  text-align: center;
}

.claim-rejection-reason {
  max-height: 50vh;
  margin: 0 24px 24px;
  overflow-y: auto;
  color: #323233;
  font-size: 16px;
  line-height: 1.7;
  text-align: left;
  white-space: pre-wrap;
  overflow-wrap: break-word;
}

.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.claim-progress-wrapper {
  margin: 12px 0;
  padding: 10px;
  background-color: #f9f9f9;
  border-radius: 6px;
}

.claim-progress-title {
  text-align: left;
  font-weight: bolder;
  font-size: 16px;
  color: #000;
  margin-bottom: 8px;
}

.claim-progress-flow {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
  font-size: 15px;
  color: #333;
}

.progress-row {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.progress-num {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 1px solid #1989fa;
  background-color: #fff;
  color: #1989fa;
  font-size: 12px;
  font-weight: bold;
}

.progress-step {
  color: #000;
  font-weight: bold;
  font-size: 14px;
  padding: 6px 10px;
  border: 1px solid #1989fa;
  border-radius: 6px;
  background-color: #ecf5ff;
}

.progress-note {
  color: #666;
  font-weight: normal;
  font-size: 14px;
  border-color: #dcdee0;
  background-color: #f7f8fa;
}

.progress-arrow {
  color: red;
  font-weight: bolder;
  font-size: 18px;
  margin: 0 2px;
}

/* 小屏幕时纵向排列，左侧序号成列，箭头竖直指向下一步骤 */
@media (max-width: 600px) {
  .claim-progress-flow {
    flex-direction: column;
    align-items: stretch;
    gap: 0;
  }

  .progress-row {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .progress-step {
    text-align: left;
    font-size: 13px;
    padding: 6px 10px;
  }

  .progress-arrow {
    transform: rotate(90deg);
    font-size: 14px;
    margin: 2px 0;
    margin-left: 6px;
    line-height: 1;
    align-self: flex-start;
  }
}
</style>
